import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';

import { InMessagePageDescription } from './in-message-page-desription.model';

@Injectable({
  providedIn: 'root',
})
export class InMessageService {
  constructor(private httpClient: HttpClient, private alcmeonContextService: AlcmeonContextService) {}

  getPageInformation(pageId: string): Observable<InMessagePageDescription> {
    return this.httpClient
      .get<InMessagePageDescription>(
        `${API_URL_COMPANIES}/${this.alcmeonContextService.companyId}/webchat/${pageId.replace(
          'p_',
          ''
        )}/page-description`
      )
      .pipe(
        catchError(() =>
          of({
            version: '2',
            position: 'bottom-right-corner',
            full_customized: false,
          })
        )
      );
  }
}
